import { CommonModule } from '@angular/common';
import {
	AfterViewInit,
	Component,
	ElementRef,
	Inject,
	OnInit,
	Renderer2,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { HeaderComponent as GbHeaderComponent } from '@bookinglab/govbook-ui/layout';
import {
  ImageDetail,
  NavLink,
} from '@bookinglab/govbook-ui/layout/lib/util/model';
@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
	standalone: true,
	imports: [CommonModule, GbHeaderComponent, MatIconModule],
})
export class HeaderComponent implements AfterViewInit {
	constructor(
		private elementRef: ElementRef<HTMLElement>,
		private renderer: Renderer2
	) {}

	goToWebsite() {
		window.open('https://www.barnsley.gov.uk/', '_blank', 'noopener,noreferrer');
	}

	imageDetail: ImageDetail = {
		alt: 'Barnsley Council information on births, deaths and marriages',
		src: 'assets/barnsley_logo.svg',
		href: 'https://www.barnsley.gov.uk/services/births-deaths-and-marriages/',
	};

	navigation: NavLink[] = [
		{
			text: 'Sign in',
			url: 'https://www.barnsley.gov.uk/online-accounts/',
		},
	];

	// BRPO-27: gb-ui-header emits an empty nav <ul>/.navbar-collapse when there
	// are no navLinks. Strip it (WCAG 1.3.1)
	ngAfterViewInit() {
		const host = this.elementRef.nativeElement;
		const collapse = host.querySelector('.navbar-collapse');
		if (!collapse || collapse.querySelector('li, a, button, input, form')) {
			return;
		}
		const toggler = host.querySelector('.navbar-toggler');
		this.renderer.removeChild(collapse.parentNode, collapse);
		if (toggler) {
			this.renderer.removeChild(toggler.parentNode, toggler);
		}
	}

	search(term: string) {
		const formatted = term.trim().replace(/\s+/g, '+');
		const url = `www.barnsley.gov.uk/search?q=${formatted}`;
		window.location.href = url;
	}
}
